import { render, staticRenderFns } from "./modal-social-club-edit-post.vue?vue&type=template&id=1590f4a3&scoped=true&lang=pug"
import script from "./modal-social-club-edit-post.js?vue&type=script&lang=js&external"
export * from "./modal-social-club-edit-post.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-club-edit-post.vue?vue&type=style&index=0&id=1590f4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590f4a3",
  null
  
)

export default component.exports